/**
 * Helper function to return an array of numbers from start to end.
 * e.g., range(1, 4) gets [1, 2, 3, 4]
 * @param start
 * @param end
 */
export function range(start: number, end: number): number[] {
  return [...Array(end - start + 1)].map((_i, idx) => idx + start);
}
